"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var SingleContent_1 = require("./SingleContent");
var DualContent_1 = require("./DualContent");
var ContentLine = function (_a) {
    var mainContent = _a.mainContent, secondaryContent = _a.secondaryContent, _b = _a.alignment, alignment = _b === void 0 ? 'flex-start' : _b, className = _a.className, dataTest = _a.dataTest;
    if (!secondaryContent) {
        return <SingleContent_1.default content={mainContent} alignment={alignment} className={className} dataTest={dataTest}/>;
    }
    return (<DualContent_1.default content={mainContent} secondaryContent={secondaryContent} className={className} alignment={alignment} dataTest={dataTest}/>);
};
exports.default = ContentLine;
